<template>
  <div class='tour'>
    <h1 class='daytour'>Rural Montenegro</h1>
    <div class='tourPic'>
      <img src='@/assets/rural/tour1/01.jpg' />
    </div>
    <div>
      <ul class='fa-ul'>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>This is the tour that will introduce you to the most authentic face of Montenegro, you will stay in regions not crowded with tourists, regions and villages known for their beauty, quality food, local traditions, you will meet the local population who will welcome you with enthusiasm, you will hear many interesting stories, try local specialties.</p>
            <p class='pasus'>Every day we will visit a farm, rural household, winery, an important village.</p>
            <p class='pasus'>We will try to be as physically active as you like, we will walk along beautiful paths around glacial lakes, through old forests, to well-known springs and river banks.</p>
            <p class='pasus'>If you are a fan of horse riding, canyoning, zip line adventure, rafting, you will be able to enjoy these adventures.</p>
            <p class='pasus'>We will visit different regions of Montenegro with their characteristic cultural heritage, get to know the flora and fauna and, of course, get to know more deeply everything you are particularly interested in.</p>
            <p class='pasus'>We will stay in areas of extraordinary natural beauty, you will have the opportunity to enjoy the view from the most spectacular viewpoints in Montenegro, admire the deepest European canyons, the clarity of rivers, the beauty of glacial lakes, old forests.</p>
            <p class='pasus'>9 days, 9 different faces of Montenegro and one incredible story.</p>
            <p class='pasus'>Welcome to Montenegro!</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: May - October</p>
            <p class='pasus'>Group size: 2-7</p>
            <p class='pasus'>Departure from: Podgorica, Tivat</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 10 days / 9 nights</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <ul class='collapse itinerary_days' id='itinerary'>
            <li>
              <a data-toggle='collapse' href='#day1'>
                <h5 class='sub-titles'>
                  Day 1 -  Lillies, birds & wine
                </h5></a
              >
              <div class='collapse' id='day1'>
                <p class='pasus'>Welcome to Europe's best kept secret!</p>
                <p class='pasus'>Not far from the capital of Montenegro - Podgorica, there is Lake Skadar, the largest lake in the Balkans, the national park of the same name, a paradise for birds, fish, reptiles, but also for people to stay balanced with nature. We will relax on a small boat ride, surrounded by birds, water lilies, reeds, hills and mountains.</p>
                <p class='pasus'>After the drive with a stop at beautiful viewpoints, we will visit one of the most interesting Montenegrin villages - Godinje, through a short walk we will get to know its architecture, but also taste wines in a local winery with an appropriate snack, in what is otherwise the most famous Montenegrin wine region.</p>
                <p class='pasus'>Accommodation: Virpazar or Podgorica/ Guest house or 4 star hotel</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day1.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day2'>
                <h5 class='sub-titles'>
                  Day 2 - Tribal tradition, Humanity & Bravery
                </h5></a
              >
              <div class='collapse' id='day2'>
                <p class='pasus'>We reserved the second day for a visit to the Žijovo mountain massif and the panoramic route called Circle around Korita, a region known for its turbulent history, multiculturalism, traditional lifestyle, and spectacular viewpoints.</p>
                <p class='pasus'>We will pass through numerous villages inhabited by Montenegrin and Albanian population, visit a local household and try the traditional dishes of this part of Montenegro.</p>
                <p class='pasus'>We will enjoy a nice walk to the famous viewpoint Grlo sokolovo with a view of the Cijevna river canyon more than 1000 m deep, see what the old cattle houses look like.</p>
                <p class='pasus'>An important part of the tour is a visit to the remains of an old Illyrian city from the 3rd century BC, as well as a visit to the museum of the famous Montenegrin warrior, writer, Marko Miljanov, whose saying about courage and humanity represents perhaps the most famous statement of Montenegrin ethical code and old traditional morality.</p>
                <p class='pasus'>Accommodation: Virpazar or Podgorica/ Guest house or 4 star hotel</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day2.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day3'
                ><h5 class='sub-titles'>
                  Day 3 - Beautiful montenegrin regions & monastery secrets
                </h5></a
              >
              <div class='collapse' id='day3'>
                <p class='pasus'>This is the day when we will move from the central region to the northern parts of Montenegro, known for their extraordinary natural beauty, numerous canyons, rivers, lakes and high mountains.</p>
                <p class='pasus'>On the way to the region of Piva, which is our final destination, we will visit the Zeta nature park, through which the river of the same name flows, a local household will introduce us to the way of life in this area, we will pass through the second largest city in Montenegro - Nikšić, and in the afternoon we will reach an ethno village on the rim of the former canyon of the Komarnica river and enjoy the beautiful view while tasting local specialties prepared in the ethno village.</p>
                <p class='pasus'>Not far away is a modest but widely known Montenegrin monastery that will tell us its unique story.</p>
                <p class='pasus'>Accomodation: Plužine/ Ethno village or Guest house</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day3.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day4'
                ><h5 class='sub-titles'>
                  Day 4 - Among katuns, sheperds and mountain peaks
                </h5></a
              >
              <div class='collapse' id='day4'>
                <p class='pasus'>This is the day in which we will cross the Durmitor mountain on perhaps the most beautiful panoramic route in Montenegro, dedicated to exploring the Durmitor mountain massif, the national park of the same name, since 1980 UNESCO site, enjoy the spectacular viewpoints, geological features of the mountain, get to know the temporary herding settlements - Katun, characteristic of the Montenegrin highlands, where the local population comes with their cattle at the beginning of summer and before the first cold days and snow comes back down from the mountain, and if you wish, enjoy horse riding.</p>
                <p class='pasus'>Accommodation: Žabljak/Ethno village or guest house</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day4.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day5'
                ><h5 class='sub-titles'>
                  Day 5 - Tear of the Europe
                </h5></a
              >
              <div class='collapse' id='day5'>
                <p class='pasus'>We reserved the fifth day of our tour for the Tara River, an adventure on the water, a view of the deepest part of the canyon, the deepest in Europe (1330 m) and a walk along the path around the Black Lake.</p>
                <p class='pasus'>We will take a ride in rubber boats down the river rapids, enjoy the view from and on the spectacular Djurdjevica Tara bridge, if preferred so, do the zip line which is one of the longest in Europe, take a walk by super-fast stream and enjoy local delicacies at lunch after the rafting.</p>
                <p class='pasus'>In the afternoon we will enjoy a walk around the Black Lake, the pearl of the national park and the largest of the total of 18 glacial lakes located in the area of the Durmitor massif.</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day5.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day6'
                ><h5 class='sub-titles'>
                  Day 6 - Medieval mistery, Old forests & cheese tasting
                </h5></a
              >
              <div class='collapse' id='day6'>
                <p class='pasus'>It's time to leave the Durmitor area, but before that we will visit two more beautiful glacial lakes and the mysterious medieval cemetery "Stećci", which will tell us the story of its origin, as far as it is known, and leave us somewhat wondering...</p>
                <p class='pasus'>We will continue the day driving through the canyon of the Tara River, where we will stop and visit an old black pine forest, impressive trees that are several centuries old and up to 50 m high.</p>
                <p class='pasus'>And before we reach the local household known for the production of the famous cheese and other specialties, we will enjoy the beauty of Biogradska Gora National Park and the glacier lake of the same name.</p>
                <p class='pasus'>Accommodation: Kolašin / Ethno village or guest house</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day6.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day7'
                ><h5 class='sub-titles'>
                  Day 7 - Multicultural heritage, walking by the accursed mountain
                </h5></a
              >
              <div class='collapse' id='day7'>
                <p class='pasus'>The northeastern region of Montenegro is significantly less visited than the others, but it really has something to offer. We will learn about life in one of the katuns in the immediate vicinity of the emperor of all Montenegrin mountains - Komovi. We will try the famous blueberry liqueur, maybe pick some along the way, Šljivovica brandy, traditional pie, walk to the mountain itself.</p>
                <p class='pasus'>We will spend the second part of the day in areas with a multicultural heritage near the border with Albania and enjoy the beauty of Lake Plav, the largest glacier lake in Montenegro, and the Prokletije National Park. We will visit the famous spring Alipašini izvori, the meeting place in the summer period for traditional events.</p>
                <p class='pasus'>Accommodation: Kolašin / Ethno village or guest house</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day7.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day8'
                ><h5 class='sub-titles'>
                  Day 8 - Down through the canyons, living by the rivers
                </h5></a
              >
              <div class='collapse' id='day8'>
                <p class='pasus'>Now it's time to head back to the central region, passing and admiring the impressive canyon of the Morača River, about 1000 m deep. We will enjoy a walk through the canyon of the Mrtvica River, maybe take a swim in its rapids, and for sure we will not miss the chance to visit one of the most interesting Montenegrin monasteries - Morača Monastery built in the 13th century.</p>
                <p class='pasus'>Accommodation: Virpazar or Podgorica/ Guest house or 4 star hotel</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day8.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day9'
                ><h5 class='sub-titles'>
                  Day 9 - Beauties of old Montenegro, Boka bay view, prosciuto & cheese tasting
                </h5></a
              >
              <div class='collapse' id='day9'>
                <p class='pasus'>We reserved the last day for the beauty of old Montenegro, a region known as the cradle of the modern Montenegrin state, proud of its libertarian tradition and centuries-old struggle against the powerful Ottoman Empire and other conquerors who tried to conquer Montenegro.</p>
                <p class='pasus'>We will visit 2 national parks, Lake Skadar and Lovćen, the old historical capital of Montenegro - Cetinje, climb the sacred Montenegrin mountain Lovćen, where on the second highest peak there is a mausoleum dedicated to the most famous Montenegrin ruler, poet and philosopher Petar II Petrović Njegoš.</p>
                <p class='pasus'>We will enjoy the spectacular view of the famous Bay of Kotor and then in the most famous Montenegrin village - Njeguši, we will taste the most famous Montenegrin food brand - Njeguši prosciutto and cheese prepared in the old way.</p>
                <p class='pasus'>Accommodation: Virpazar or Podgorica/ Guest house or 4 star hotel</p>
                <img
                  class='daypic'
                  src='@/assets/rural/tour1/day9.jpg'
                />
              </div>
            </li>
            <li>
              <a data-toggle='collapse' href='#day10'
                ><h5 class='sub-titles'>
                  Day 10 - Transfer to the airport
                </h5></a
              >
              <div class='collapse' id='day10'>
                <p class='pasus'>After breakfast, a transfer to Podgorica or Tivat airport is organized.</p>
              </div>
            </li>
            <li>
              <p class='pasus'>TOUR DATES: On request</p>
            </li>
          </ul>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'>
            <h4 class='titles'>
              PRICE: based on the number of people in your group
            </h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li>2300 euro per person when two traveling</li>
              <li>1750 euro per person when four traveling</li>
              <li>1700 euro per person when six traveling</li>
              <li>Single room supplement: 300 EUR</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'>
            <h4 class='titles'>What is included in the price</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Accommodations for 9 nights</li>
              <li class='pasus'>Transportation (van or car) </li>
              <li class='pasus'>Breakfast And Dinner for all days</li>
              <li class='pasus'>Lunch on the day 2,4,5,6</li>
              <li class='pasus'>Wine tasting (wine+snacks)</li>
              <li class='pasus'>Bottle of water 0.5l on each day</li>
              <li class='pasus'>Transfer to the airport on the last day</li>
              <li class='pasus'>Rafting, professional guide and safety equipment</li>
              <li class='pasus'>Private boat tour on Skadar Lake (1h) </li>
              <li class='pasus'>Entrance fees for all national and regional parks, museums</li>
              <li class='pasus'>Our on-site assistance 24/7</li>
              <li class='pasus'>Licensed Tour Guide</li>
              <li class='pasus'>Map of Montenegro</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#notincluded'>
            <h4 class='titles'>Not included in price</h4></a
          >
          <div class='collapse' id='notincluded'>
            <ul class='square'>
              <li>Options as mentioned</li>
              <li>Lunches not specified in the program</li>
              <li>Drinks and tips</li>
              <li>Personal expenses</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'>
            <h4 class='titles'>Practical info</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>We recommend always carrying a jacket, cap, glasses and sun cream, and footwear suitable for mountain conditions. More frequent weather changes are possible in mountainous areas.</li>
              <li class='pasus'>The height difference we cross is about 1850 m. We start with 50 and the highest point is at a height of about 1900 m</li>
              <li class='pasus'>Prices in restaurants and bars are very affordable</li>
              <li class='pasus'>The currency is Euro</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img
              style='width: 35px; margin-left: 0px; margin-top: 0px'
              src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'>
            <h4 class='titles'>Optional</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>Changes in the itinerary during the tour by agreement (do not affect the price)</li>
              <li class='pasus'>Zip line across the Tara canyon (ticket 20 eur)</li>
              <li class='pasus'>Rent a Boat ride on Biogradsko or Black lake (1h- 8 eur)</li>
              <li class='pasus'>Horse Riding (1h -20 eur)</li>
              <li class='pasus'>Panoramic cable car ride (8 EUR)</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/rural/tour1/h1.jpg'),
          thumbnail: require('@/assets/rural/tour1/h1.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h2.jpg'),
          thumbnail: require('@/assets/rural/tour1/h2.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h3.jpg'),
          thumbnail: require('@/assets/rural/tour1/h3.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h4.jpg'),
          thumbnail: require('@/assets/rural/tour1/h4.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h5.jpg'),
          thumbnail: require('@/assets/rural/tour1/h5.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h6.jpg'),
          thumbnail: require('@/assets/rural/tour1/h6.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h7.jpg'),
          thumbnail: require('@/assets/rural/tour1/h7.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h8.jpg'),
          thumbnail: require('@/assets/rural/tour1/h8.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h9.jpg'),
          thumbnail: require('@/assets/rural/tour1/h9.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h10.jpg'),
          thumbnail: require('@/assets/rural/tour1/h10.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h11.jpg'),
          thumbnail: require('@/assets/rural/tour1/h11.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h12.jpg'),
          thumbnail: require('@/assets/rural/tour1/h12.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h13.jpg'),
          thumbnail: require('@/assets/rural/tour1/h13.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h14.jpg'),
          thumbnail: require('@/assets/rural/tour1/h14.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h15.jpg'),
          thumbnail: require('@/assets/rural/tour1/h15.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h16.jpg'),
          thumbnail: require('@/assets/rural/tour1/h16.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h17.jpg'),
          thumbnail: require('@/assets/rural/tour1/h17.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h18.jpg'),
          thumbnail: require('@/assets/rural/tour1/h18.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h19.jpg'),
          thumbnail: require('@/assets/rural/tour1/h19.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h20.jpg'),
          thumbnail: require('@/assets/rural/tour1/h20.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h21.jpg'),
          thumbnail: require('@/assets/rural/tour1/h21.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h22.jpg'),
          thumbnail: require('@/assets/rural/tour1/h22.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h23.jpg'),
          thumbnail: require('@/assets/rural/tour1/h23.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h24.jpg'),
          thumbnail: require('@/assets/rural/tour1/h24.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h26.jpg'),
          thumbnail: require('@/assets/rural/tour1/h26.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h27.jpg'),
          thumbnail: require('@/assets/rural/tour1/h27.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h29.jpg'),
          thumbnail: require('@/assets/rural/tour1/h29.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h30.jpg'),
          thumbnail: require('@/assets/rural/tour1/h30.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h32.jpg'),
          thumbnail: require('@/assets/rural/tour1/h32.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h33.jpg'),
          thumbnail: require('@/assets/rural/tour1/h33.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h34.jpg'),
          thumbnail: require('@/assets/rural/tour1/h34.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h35.jpg'),
          thumbnail: require('@/assets/rural/tour1/h35.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/rural/tour1/h36.jpg'),
          thumbnail: require('@/assets/rural/tour1/h36.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.daypic {
  width: 60vw;
  margin-bottom:20px;
}
.pasus {
  text-align: justify;
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/RT1_RuralMontenegro.vue